import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Col, Layout, message, Modal, Row } from 'antd';
import { get } from 'lodash';
import queryString from 'query-string';

import PdButton from 'components/pd-button';
import { TableList } from 'components/table-list';

import RentService from 'services/rent';

const { Content } = Layout;
const { confirm } = Modal;

export function RentDurations() {
  const [durationList, setDurationList] = useState([]);
  const [loadStatus, setLoadStatus] = useState(false);
  const location = useLocation();
  const parsed = queryString.parse(get(location, 'search', ''));

  const fetchDurationList = async () => {
    try {
      setLoadStatus(true);
      const { data } = await RentService.getRentDurations();
      const durations = get(data, 'data', []);

      setDurationList(durations);
      setLoadStatus(false);
    } catch (error) {
      message.error(
        get(
          error,
          'response.data.message',
          'Cannot connect to server, please check connection'
        )
      );
    } finally {
      setLoadStatus(false);
    }
  };

  const durationRow = (row) => <div>{row.duration} Days</div>;

  const coloredStatus = (row) => (
    <div className="status-indicator">
      <span className={row.status !== 'inactive' ? 'active' : 'hidden'}>
        {row.status === ''
          ? ''
          : row.status.charAt(0).toUpperCase() + row.status.slice(1)}
      </span>
    </div>
  );

  const tableButton = (row) => (
    <div className="button-table">
      <Row>
        <Col span={12}>
          {row.status === 'active' ? (
            <PdButton
              onClick={handleDeactivate.bind(this, row.id)}
              type="danger"
              outline
              style={{ width: '90%', height: 32, margin: 5 }}>
              Deactivate
            </PdButton>
          ) : (
            <PdButton
              onClick={handleRestore.bind(this, row.id)}
              type="primary"
              outline
              style={{ width: '90%', height: 32, margin: 5 }}>
              Reactivate
            </PdButton>
          )}
        </Col>
        <Col span={12}>
          {row.status === 'active' ? (
            <Link
              to={{
                pathname: "/rent_durations/edit",
                search: `id=${row.id}`,
                state: { prevPath: '/rent_durations', parsed },
              }}>
              <PdButton
                type="primary"
                style={{ width: '90%', height: 32, margin: 5 }}>
                Edit
              </PdButton>
            </Link>
          ) : (
            <PdButton
              type="danger"
              onClick={handleDelete.bind(this, row.id)}
              style={{ width: '90%', height: 32, margin: 5 }}>
              Delete
            </PdButton>
          )}
        </Col>
      </Row>
    </div>
  );

  const columns = [
    {
      name: 'Duration',
      cell: durationRow,
      width: '30%',
      center: true,
    },
    {
      name: 'Status',
      cell: coloredStatus,
      width: '40%',
      center: true,
    },
    {
      name: '',
      cell: tableButton,
      width: '30%',
      center: true,
    },
  ];

  async function deactivateDuration(id) {
    try {
      setLoadStatus(true);
      if (id) {
        await RentService.deactivateRentDuration(id);
        message.success('Successfully deactivate duration');
      }
    } catch (error) {
      message.error(
        get(
          error,
          'response.data.message',
          'Cannot connect to server, please check connection'
        )
      );
    } finally {
      fetchDurationList();
      setLoadStatus(false);
    }
  }

  async function deleteDuration(id) {
    try {
      setLoadStatus(true);
      if (id) {
        await RentService.deleteRentDuration(id);
        message.success('Successfully removed duration');
      }
    } catch (error) {
      message.error(
        get(
          error,
          'response.data.message',
          'Cannot connect to server, please check connection'
        )
      );
    } finally {
      fetchDurationList();
      setLoadStatus(false);
    }
  }

  const handleDeactivate = async (id) => {
    confirm({
      title: 'Are you sure you want to deactivate this duration?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deactivateDuration(id);
      },
      onCancel() {},
    });
  };

  const handleDelete = async (id) => {
    confirm({
      title: 'Are you sure you want to delete?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteDuration(id);
      },
      onCancel() {},
    });
  };

  const handleRestore = async (id) => {
    try {
      setLoadStatus(true);
      if (id) {
        await RentService.reactivateRentDuration(id);
        message.success('Successfully restored duration');
      }
    } catch (error) {
      message.error(
        get(
          error,
          'response.data.message',
          'Cannot connect to server, please check connection'
        )
      );
    } finally {
      fetchDurationList();
      setLoadStatus(false);
    }
  };

  useEffect(() => {
    fetchDurationList();
  }, []);

  return (
    <Layout className="pd-cms-durations main-container">
      <div className="content">
        <div className="pageTitle">Duration</div>
        <Content className="pageContent">
          <Row>
            <Col span={3} offset={19}>
              <Link
                to={{
                  pathname: `/rent_durations/create`,
                  state: { prevPath: '/rent_durations', parsed },
                }}>
                <PdButton
                  type="primary"
                  full
                  outline
                  style={{ height: 32, width: 176 }}>
                  Add New Rent Duration
                </PdButton>
              </Link>
            </Col>

            <Col xs={24} className="">
              <TableList
                changePage={{}}
                columns={columns}
                loadingOrder={loadStatus}
                nextPage={-1}
                orderList={durationList}
                page={1}
                responsive={false}
              />
            </Col>
          </Row>
        </Content>
      </div>
    </Layout>
  );
}

export default { RentDurations };
